import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MetaService} from '../../../services/meta/meta.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {AssessmentService} from '../../../services/assessment/assessment.service';
import {AudioService} from '../../../services/audio/audio.service';
import {GameImagePipe} from '../../../pipes/game-image.pipe';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-assessment-questions',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    GameImagePipe,
    SpinnerComponent
  ],
  templateUrl: './assessment-questions.component.html',
  styleUrls: ['./assessment-questions.component.scss']
})
export class AssessmentQuestionsComponent implements OnInit {

  loading = true;
  question: any;
  selectedAnswer: any;
  freeText = '';
  submitting = false;
  gapParts: string[] = [];

  constructor(
    private metaSrv: MetaService,
    private translate: TranslateService,
    public langSrcSrv: LangSrcService,
    private router: Router,
    private assessmentSrv: AssessmentService,
    public audioSrv: AudioService
  ) {
  }

  trackByIndex(index: number) { return index; }

  async ngOnInit() {
    this.translate.get(`Test de fin de formation`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    // Repassable à volonté : start démarre une nouvelle tentative ou reprend celle en cours
    const response: any = await this.assessmentSrv.start();
    await this.handleResponse(response);
  }

  async handleResponse(response: any) {
    if (!response || response.finished) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'assessment', 'result']);
      return;
    }
    this.question = response.question;
    this.gapParts = (this.question.type === 'gap_fill' && this.question.translation)
      ? this.question.translation.split('[?]')
      : [];
    this.selectedAnswer = null;
    this.freeText = '';
    this.loading = false;
  }

  get progressPercent(): number {
    if (!this.question?.total) return 0;
    return Math.round(((this.question.index - 1) / this.question.total) * 100);
  }

  async selectAnswer(answer: any) {
    if (this.submitting) return;
    this.selectedAnswer = answer;
    if (answer.audio) {
      await this.audioSrv.play(answer.audio);
    }
  }

  get canSubmit(): boolean {
    if (!this.question || this.submitting) return false;
    if (this.question.freeInput) return this.freeText.trim().length > 0;
    return !!this.selectedAnswer;
  }

  async submit() {
    if (!this.canSubmit) return;
    const values: any = {question: this.question.uniqid};
    if (this.question.freeInput) {
      values.freeText = this.freeText.trim();
    } else {
      values.answer = this.selectedAnswer.uniqid;
    }
    await this.send(values);
  }

  async skip() {
    if (this.submitting) return;
    await this.send({question: this.question.uniqid});
  }

  private async send(values: any) {
    this.submitting = true;
    try {
      const response: any = await this.assessmentSrv.answer(values);
      await this.handleResponse(response);
    } finally {
      this.submitting = false;
    }
  }

  // La tentative reste en "in_progress" côté serveur : elle se reprend au même endroit
  async quit() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'assessment']);
  }

}
